module.exports = __webpack_public_path__ + "static/fipcbrownleopard4-54e1f1a78c9b7a5e8303fdb52959578d.jpeg";